module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty10.435c8897.jpg";